export const QA_NAME_CALENDAR_RELIEVE_DAY_MODAL = 'calendarRelieveDay'

export const CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE = 'date'

export const CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS = 'follow_up_ids'

export const QA_NAME_CALENDAR_RELIEVE_DAY_SUBTITLE =
  'calendarRelieveDaySubtitle'

export const QA_NAME_CALENDAR_RELIEVE_DAY_AFTER = 'calendarRelieveDayAfter'

export const QA_NAME_CALENDAR_RELIEVE_DAY_TARGET_LOAD =
  'calendarRelieveDayTargetLoad'
